import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";

import logo from "../Components/images/logo.png";
import logo1 from "../Components/images/logo1.jpeg";

const HomeCompoTwo = () => {
  const [modalImage, setModalImage] = useState(null);
  const [images, setImages] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const openImage = (img) => setModalImage(img);
  const closeImage = () => setModalImage(null);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch("https://dropshopi.com/api/all-uploads.php");
        const data = await res.json();
        if (data.status === "success") {
          const filtered = data.data.filter((img) => img.type === "Shopify");
          setImages(filtered.map((img) => img.image_path));
        }
      } catch (err) {
        console.error("Failed to fetch images", err);
      }
    };

    fetchImages();
  }, []);

  return (
    <>
      {/* Desktop View */}
      {!isMobile && (
        <div
          className="container-result d-flex flex-column justify-content-center align-items-center text-center px-3"
          style={{
            marginTop: "30px",
            paddingTop: "40px",
            paddingBottom: "20px",
          }}
        >
          <h2
            className="display-3 fw-bold anton ft3 mt-2"
            style={{ maxWidth: "1000px" }}
          >
            Shopify Success  <span className="text-warning"> Stories.</span>
          </h2>

          <div className="container-fluid scroll-container">
            <div className="scroll-wrapper d-flex">
              <div className="d-flex gap-3 group">
                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}
                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}

                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}


                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}

                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div> 
        </div>
      )}

      {/* Mobile View Slider */}
      {isMobile && (
        <div className="container px-2 py-4 text-center">
          <h2 className="display-3 fw-bold anton ft3 mt-2 mb-3">
            Shopify Success  <span className="text-warning"> Stories.</span>
          </h2>
          <Slider {...sliderSettings}>
            {images.map((img, i) => (
              <div key={i} onClick={() => openImage(img)}>
                <img
                  src={img}
                  alt={`slide-${i}`}
                  className="img-fluid rounded"
                  style={{ height: "200px", objectFit: "fill", margin: "0 auto" }}
                />
              </div>
            ))}
          </Slider>
        </div>
      )}

      {/* Lightbox Modal */}
      {modalImage && (
        <div className="fullscreen-modal" onClick={closeImage}>
          <span className="close-btn" onClick={closeImage}>
            &times;
          </span>
          <img
            src={modalImage}
            className="fullscreen-image"
            alt="Enlarged preview"
          />
        </div>
      )}
    </>
  );
};

export default HomeCompoTwo;
